import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapEnvironmentVars, EnvService } from 'frontend-environment';
import { AppModule } from './app/app.module';

/**
 * technically we just need the bootstrapApplication function
 * but in attempts to get environment vars connected I ran into major issues
 * this approach was taken from the other apps
 * It doesn't work yet. Look at the proxy.conf.mjs file or run the server and watch the errors
 */

bootstrapEnvironmentVars({
  /* environment.json overrides
     This should be exceptionally rare, usually just for local
     testing when testing against prod environment.json
     example:
      FRONTEND_HOSTNAME: 'local-ninja.demandscienceplatform.ninja'
   */
})
  .then((env) => {
    platformBrowserDynamic([
      {
        provide: EnvService,
        useValue: new EnvService(env),
      },
    ]).bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
